(() => {
  const targetSelector = [
    '.trots-hero-carousel__heading',
    '.trots-collection-hero__heading',
    '.trots-footer__newsletter-heading',
    '.trots-quiz-modal__content .quiz-to-action-container > h2',
    '.trots-newsletter-quiz__quiz-heading',
    '.trots-newsletter-quiz__signup-heading',
    '.trots-newsletter-quiz__success-card h3',
  ].join(',');

  const wrapTextNode = (textNode) => {
    const fragment = document.createDocumentFragment();

    Array.from(textNode.nodeValue).forEach((character) => {
      if (/\s/.test(character)) {
        fragment.append(document.createTextNode(character));
        return;
      }

      const characterElement = document.createElement('span');
      characterElement.className = 'trots-tight-tracking__character';
      characterElement.textContent = character;
      fragment.append(characterElement);
    });

    textNode.replaceWith(fragment);
  };

  const applyTracking = (element) => {
    if (!(element instanceof HTMLElement) || element.dataset.trotsTightTracking === 'true') return;

    const textNodes = [];
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);

    while (walker.nextNode()) {
      if (walker.currentNode.nodeValue.trim()) textNodes.push(walker.currentNode);
    }

    textNodes.forEach(wrapTextNode);
    element.dataset.trotsTightTracking = 'true';
  };

  const scan = (root = document) => {
    if (root instanceof Element && root.matches(targetSelector)) applyTracking(root);
    root.querySelectorAll?.(targetSelector).forEach(applyTracking);
  };

  const init = () => {
    scan();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach(({ addedNodes }) => {
        addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) scan(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
